import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import './App.css';
import Footer from "./components/Footer";
import ContactPage from "./components/ContactPage";
import Team from "./components/Team";
import Peter from "./components/Peter";
import Info3 from "./components/Info3";
import BuyHome from "./components/BuyHome";
import PolicyPage from "./components/PolicyPage";
import Fastigheter from "./components/Fastigheter";
import FastigheterInfo from "./components/FastigheterInfo";
import AllaFastigheter from "./components/AllaFastigheter";
import SoldFastigheter from "./components/SoldFastigheter.js";
import ScrollToTop from "./components/ScrollToTop";
import Philosophy from "./components/Philosophy.js";
import PoweredByBanner from "./components/PoweredByBanner.js";
import LocalTips from "./components/LocalTips.js";
import CookieBanner from "./components/CookieBanner.js";


function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <ScrollToTop /> 


        <div className="main-content">

          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />

                  <div className="section-wrapper">
                    <Fastigheter />
                  </div>

                  <div className="section-wrapper">
                    <LocalTips />
                  </div>

                  <div className="section-wrapper">
                    <Team />
                  </div>

                  <div className="section-wrapper">
                   <Philosophy/>
                  </div>
                  

                  <div className="section-wrapper">
                    <Info3 />
                  </div>
                </>
              }
            />

            <Route path="/peter" element={<Peter />} />
            <Route path="/alla-fastigheter" element={<AllaFastigheter />} />
            <Route path="/soldObjects" element={<SoldFastigheter />} />
            <Route path="/buyhome" element={<BuyHome />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/policy" element={<PolicyPage />} />
            <Route path="/fastighet/:id" element={<FastigheterInfo />} />
          </Routes>
        </div>

        <Footer />
        <CookieBanner/>
        <PoweredByBanner />
      </div>
    </Router>
  );

}

export default App;
